module.exports = __webpack_public_path__ + "assets/img/kristijonas.b7ca9733.png";